import React, { useEffect, useState } from 'react';
import './Footer.css';

function Footer() {
    const locations = [
        '📍 Bhubaneswar',
        '📍 Rourkela',
        '📍 Berhampur',
        '📍 Hyderabad',
        '📍 Bengaluru',
        '📍 Mangalore',
        '📍 Delhi',
        '📍 Kolkata'
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % locations.length);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <footer className="footer" id="footer">
            <div className="footer-grid">
                <div>
                    <h4>Contact Us</h4>
                    <div className="location-scroll">
                        {locations[currentIndex]}
                    </div>
                    {/* ✅ Click to Call */}
                    <p>
                        📞 <a href="tel:+917653009332" className="footer-link">+91 7653009332</a>
                    </p>
                    {/* ✅ Click to Email */}
                    <p>
                        📧 <a href="mailto:rapidphysio6@gmail.com" className="footer-link">rapidphysio6@gmail.com</a>
                    </p>
                </div>

                <div>
                    <h4>Opening Hours</h4>
                    <p>8:00 AM – 9:00 PM</p>
                </div>

                <div>
                    <h4>Follow Us</h4>
                    <div className="social-icons">
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                            <img src="https://img.icons8.com/ios-filled/22/ffffff/facebook-new.png" alt="Facebook" />
                        </a>
                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                            <img src="https://img.icons8.com/ios-filled/22/ffffff/instagram-new.png" alt="Instagram" />
                        </a>
                        <a href="https://wa.me/917653009332" target="_blank" rel="noopener noreferrer">
                            <img src="https://img.icons8.com/ios-filled/22/ffffff/whatsapp.png" alt="WhatsApp" />
                        </a>
                    </div>
                </div>
            </div>

            {/* Visitor Counter */}
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <p style={{ fontSize: '12px', margin: '5px 0' }}>Total Visitors:</p>
                <a
                    href="https://www.hitwebcounter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="https://hitwebcounter.com/counter/counter.php?page=21172970&style=0036&nbdigits=5&type=page&initCount=0"
                        title="Counter Widget"
                        alt="Visit counter For Websites"
                        style={{ border: 0 }}
                    />
                </a>
            </div>

            <p style={{ marginTop: '10px', fontSize: '12px' }}>
                © {new Date().getFullYear()} Rapid Physio. All rights reserved.
            </p>
        </footer>
    );
}

export default Footer;
